/**
 * File: src/app-router.js
 * Mô tả: Bộ định tuyến SPA (Client-side Router) quản lý điều hướng giữa /, /games/ant-clash, /ant-clash/privacy và /admin.
 * Liên quan: src/main.js, src/pages/home-page.js, src/pages/game-detail-page.js, src/pages/privacy-page.js, src/pages/admin-page.js
 */

import { updateMetadata } from './services/seo-service.js';
import { trackPageView } from './services/analytics-service.js';
import { games } from './data/games.js';

import { renderHomePage } from './pages/home-page.js';
import { renderGameDetailPage } from './pages/game-detail-page.js';
import { renderBeatglidePrivacyPage } from './pages/beatglide-privacy-page.js';
import { renderPrivacyPage } from './pages/privacy-page.js';
import { renderAdminPage } from './pages/admin-page.js';

export const initAppRouter = (mainContainer) => {
  if (!mainContainer) return;

  const navigateToPath = (pathname) => {
    pathname = pathname.replace(/\/$/, '') || '/';
    mainContainer.innerHTML = '';
    window.scrollTo(0, 0);

    if (pathname === '/admin' || pathname === '/admin/') {
      mainContainer.appendChild(renderAdminPage());
      document.title = 'SNT Games — Cổng Quản Trị Cấu Hình (Admin)';
    } else if (pathname === '/beatglide/terms') {
      mainContainer.appendChild(renderBeatglidePrivacyPage(true));
    } else if (['/beatglide/privacy', '/games/beatglide/privacy', '/privacy/beatglide'].includes(pathname)) {
      mainContainer.appendChild(renderBeatglidePrivacyPage());
    } else if (pathname === '/ant-clash/privacy' || pathname === '/games/ant-clash/privacy' || pathname === '/privacy/ant-clash') {
      mainContainer.appendChild(renderPrivacyPage('ant-clash'));
      document.title = 'Privacy Policy — Ant Clash | SNT Games Studio';
    } else if (pathname === '/games/ant-clash' || pathname === '/games/ant-clash/' || pathname === '/ant-clash' || pathname === '/ant-clash/') {
      mainContainer.appendChild(renderGameDetailPage('ant-clash'));
      document.title = 'Ant Clash — 2D Real-Time Strategy Game | SNT Games';
    } else if (games.some((game) => pathname.replace(/\/$/, '') === `/games/${game.id}`)) {
      const game = games.find((game) => pathname.replace(/\/$/, '') === `/games/${game.id}`);
      mainContainer.appendChild(renderGameDetailPage(game.id));
      document.title = `${game.title} | SNT Games`;
    } else if (pathname === '/') {
      mainContainer.appendChild(renderHomePage());
      document.title = 'SNT Games — Independent Game Studio in Hanoi, Vietnam';
    } else {
      mainContainer.innerHTML = '<section class="section" style="padding-top: 120px;"><div class="container"><h1>404</h1><p>Trang không tồn tại / Page not found.</p><a class="btn btn-primary" href="/">SNT Games</a></div></section>';
    }
    updateMetadata(pathname);
    trackPageView();
  };

  const scrollToLocation = () => {
    const sectionId = window.location.hash.slice(1);
    const section = sectionId ? document.getElementById(sectionId) : null;
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (!sectionId) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  let renderedPath = window.location.pathname;
  const syncLocation = () => {
    if (renderedPath !== window.location.pathname) {
      navigateToPath(window.location.pathname);
      renderedPath = window.location.pathname;
    }
    scrollToLocation();
  };

  window.addEventListener('popstate', syncLocation);

  // Chỉ chặn click điều hướng thông thường; giữ hành vi mở tab và tải file.
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const targetLink = e.target.closest('a');
    if (!targetLink || targetLink.hasAttribute('target') || targetLink.hasAttribute('download')) return;

    const href = targetLink.getAttribute('href');
    if (!href || !href.startsWith('/') || href.startsWith('//')) return;

    const destination = new URL(href, window.location.href);
    if (destination.origin !== window.location.origin) return;
    e.preventDefault();
    if (destination.href !== window.location.href) {
      window.history.pushState({}, '', destination.pathname + destination.search + destination.hash);
    }
    syncLocation();
  });

  navigateToPath(window.location.pathname);
  scrollToLocation();
};
